import { ValidationInterface } from '../../validation.interface';
import { FeedstockNpk, FeedstockNpkPropName } from '../../../../models/project/feedstock/feedstock-npk.model';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';

export class FeedstockNpkValidation implements ValidationInterface {
  /** The current feedstock NPK obj that is being validated */
  npk: FeedstockNpk;

  /**
   * Sets the feedstock NPK that will be used for validation
   * @param npk will be used to set the current feedstock NPK obj
   */
  constructor(npk: FeedstockNpk) {
    if (!npk) throw Error('invalid feedstock NPK provided for validation');
    this.npk = new FeedstockNpk(npk);
  }

  /**
   * Get a validation unit containing the validation data for the current feedstock NPK obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.npk) throw Error('unable to validate feedstock NPK');
    const validationUnit = new ProjectValidationUnit();
    validationUnit.addModuleResults(
      new UnitValueValidation(this.npk.nitrogen).getValidation(),
      FeedstockNpkPropName.nitrogen
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.npk.phosphorus).getValidation(),
      FeedstockNpkPropName.phosphorus
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.npk.potassium).getValidation(),
      FeedstockNpkPropName.potassium
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.npk.ammoniaNitrogen).getValidation(),
      FeedstockNpkPropName.ammoniaNitrogen
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current feedstock NPK obj is valid
   */
  isValid(): boolean {
    return false;
  }
}
